module.exports = __webpack_public_path__ + "img/h_1_gs.89079bdb.png";